import Conditions from '../constants/conditions';
import RoutesComponents from '../../permissions/constants/routesComponents';
import UserPermissions from '../constants/userPermissions';
import { PartialRecord, PermissionRules } from '../usePermissions';

type routesComponentRegistry = {
  [name in RoutesComponents]: PermissionRules;
};

const RoutesComponentRegistry: routesComponentRegistry = {
  AssignedTo: {
    [UserPermissions.ASSIGN_DRIVERS_TO_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
  DetailsPanel: {
    [UserPermissions.VIEW_VISITS]: true,
    [UserPermissions.VIEW_ROUTES]: true,
  },
  DownloadCSV: {
    [UserPermissions.DOWNLOAD_SOLUTION]: true,
  },
  PublishButton: {
    [UserPermissions.DISPATCH_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      if (conditions.isOptimizing) return false;
      if (conditions.isPublishing) return false;
      return true;
    },
  },
  UnpublishButton: {
    [UserPermissions.DISPATCH_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      if (conditions.isOptimizing) return false;
      if (conditions.isPublishing) return false;
      return true;
    },
  },
  RouteDetailsPanel: {
    // Editing stays open once published and once started. Which fields are still actionable narrows
    // inside the edit modal rather than here, so only a finished route has nothing left to change.
    [UserPermissions.EDIT_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      if (conditions.isFinished) return false;
      if (conditions.isLocked) return false;
      return true;
    },
    [UserPermissions.DELETE_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      if (conditions.isDispatched) return false;
      if (conditions.isLocked) return false;
      return true;
    },
    // Reoptimize and draw route rebuild the stop sequence from scratch, so the backend keeps them
    // closed to published routes.
    [UserPermissions.CREATE_OPTIMIZATION]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      if (conditions.isDispatched) return false;
      if (conditions.isLocked) return false;
      return true;
    },
    // Reverse route only flips the existing sequence, which the backend allows on a published route
    // right up until the driver starts it.
    [UserPermissions.ASSIGN_STOPS_TO_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      if (conditions.isStarted) return false;
      if (conditions.isLocked) return false;
      return true;
    },
    [UserPermissions.CREATE_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
  RouteGanttGroupInner: {
    [UserPermissions.VIEW_DRIVERS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
  RoutesTable: {
    [UserPermissions.DELETE_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
  RoutesMultiSelectActionBar: {
    [UserPermissions.CREATE_OPTIMIZATION]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
    [UserPermissions.DISPATCH_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
    [UserPermissions.DELETE_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
    [UserPermissions.CREATE_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
    [UserPermissions.EDIT_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
  RoutesEmptyState: {
    [UserPermissions.CREATE_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
  RoutesPanel: {
    [UserPermissions.CREATE_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
    [UserPermissions.EDIT_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
  RouteSummary: {
    [UserPermissions.CREATE_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
  StandardRouteCard: {
    [UserPermissions.EDIT_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
  TimelineCard: {
    [UserPermissions.ASSIGN_STOPS_TO_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
};

export default RoutesComponentRegistry;
